import SectionTitle from "../common/SectionTitle";
import CheckListItem from "../common/CheckListItem";
import { siteData } from "../data/siteData";
import { MapPin } from "lucide-react";
import SeoHelper from '../common/SeoHelper';
const Location = () => {
  const advantages = [
    "Strategically located in a well-connected and rapidly developing area",
    "Easy access to major roads and key city routes",
    "Close proximity to reputed schools, colleges, and educational institutions",
    "Nearby hospitals and healthcare facilities for everyday convenience",
    "Quick access to shopping areas, daily essentials, and commercial hubs",
    "Peaceful surroundings away from city congestion, yet well-connected",
    "Ideal location for both comfortable living and long-term investment",
    "Strong future growth potential supported by planned infrastructure development",
  ];

  return (
    <>
    <SeoHelper/>
    <section id="location" className="pt-24 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          title="Prime Location"
          subtitle="Perfectly positioned for convenience and growth"
        />

        <div className="grid lg:grid-cols-2 mt-10 gap-12">
          <div className="space-y-8">
            <div className="bg-emerald-50 p-6 rounded-xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center space-x-2">
                <MapPin className="text-emerald-600" />
                <span>Site Address</span>
              </h3>
              <p className="text-lg text-gray-700">
                {siteData.contact.siteAddress}
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Location Advantages
              </h3>
              <div className="space-y-3">
                {advantages.map((advantage, idx) => (
                  <CheckListItem key={idx} text={advantage} />
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="aspect-video rounded-2xl shadow-xl overflow-hidden">
              <iframe
                title="Google Map"
                src="https://www.google.com/maps?q=Outer%20Ring%20Road%20Lucknow&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <h4 className="font-bold text-gray-900 mb-4">Office Location</h4>
              <p className="text-gray-700">
                {siteData.contact.officeAddress.line1}
                <br />
                {siteData.contact.officeAddress.line2}
                <br />
                {siteData.contact.officeAddress.line3}
                <br />
                {siteData.contact.officeAddress.line4}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};
export default Location;
